module.exports = __webpack_public_path__ + "img/HMPPS-SMALL-BLACK.2d718cf4.jpg";